module.exports = __webpack_public_path__ + "static/media/HeroImg.d35311d9.svg";